<template>
  <div>
    <div>
      <el-form
        v-if="isCreat"
        ref="form"
        :rules="rules"
        :model="userInfo"
        label-width="80px"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="售后类型" prop="category">
              <el-select
                clearable
                v-model="userInfo.category"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in afterSaleType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来源">
              <el-select
                clearable
                v-model="userInfo.source"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in originType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户姓名">
              <el-input
                clearable
                v-model="userInfo.customerName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系方式">
              <el-input
                clearable
                v-model="userInfo.contact"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="问题描述" prop="problemDescription">
            <el-input
              type="textarea"
              v-model="userInfo.problemDescription"
              placeholder="请输入文字描述，限制4-200字符。"
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="图片/视频：（请上传最多5张JPEG/PNG/GIF图片或MP4视频，总大小不超30MB）"
          >
            <div class="">
              <uploadFile
                @fileChange="fileChange"
                :attachmentList="[...attachmentLists]"
              ></uploadFile>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="userInfo.remarks"
              placeholder="请输入文字描述，限制200字符。"
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div v-else>
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content">
              <span class="label-left">售后类型：</span
              ><span class="desc-text">{{
                getAfterSaleText(userInfo.category) || "-"
              }}</span>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <span class="label-left">来源：</span
              ><span class="desc-text">{{
                getSourceText(userInfo.source) || "-"
              }}</span>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content">
              <span class="label-left">售后单编号：</span
              ><span class="desc-text">{{ userInfo.code || "-" }}</span>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <span class="label-left">提交人：</span
              ><span class="desc-text">{{ userInfo.creatorName || "-" }}</span>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <span class="label-left">提交时间：</span
              ><span class="desc-text">{{ userInfo.createdAt || "-" }}</span>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" class="grid-item">
            <div class="grid-content">
              <span class="label-left">客户姓名：</span>
              <span class="desc-text" v-if="editCusName">{{
                userInfo.customerName || "-"
              }}</span>
              <el-input
                @blur="editCusName = true"
                v-else
                size="mini"
                v-model="userInfo.customerName"
              ></el-input>
            </div>
            <div
              class="grid-item-edit"
              v-if="!notShowEditText.includes(orderData.status)"
              @click="editCusName = false"
            >
              修改
            </div>
          </el-col>
          <el-col :span="8" class="grid-item"
            ><div class="grid-content">
              <span class="label-left">联系方式：</span>
              <span class="desc-text" v-if="editContact">{{
                userInfo.contact || "-"
              }}</span>
              <el-input
                v-else
                @blur="editContact = true"
                size="mini"
                v-model="userInfo.contact"
              ></el-input>
            </div>
            <div
              class="grid-item-edit"
              v-if="!notShowEditText.includes(orderData.status)"
              @click="editContact = false"
            >
              修改
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="23" class="grid-item">
            <div class="grid-content" style="width: 90%">
              <span class="label-left">问题描述：</span>
              <span
                v-if="editDesc"
                class="desc-text overflow-text"
                :title="userInfo.problemDescription"
                >{{ userInfo.problemDescription || "-" }}</span
              >
              <el-input
                type="textarea"
                :rows="2"
                v-else
                @blur="editDesc = true"
                size="mini"
                v-model="userInfo.problemDescription"
              ></el-input>
            </div>
            <div
              class="grid-item-edit"
              v-if="!notShowEditText.includes(orderData.status)"
              @click="editDesc = false"
            >
              修改
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="grid-content">
              <div class="label-left picture-video">图片/视频：</div>
              <div
                class="picture-space"
                v-if="attachmentLists && attachmentLists.length > 0"
              >
                <imgPreview :attachmentList="[...attachmentLists]"></imgPreview>
                <!-- <uploadFile
                  :showDel="false"
                  @fileChange="fileChange"
                  :attachmentList="[...attachmentLists]"
                ></uploadFile> -->
                <!-- <img v-for="i in attachmentLists" :key="i" :src="i" /> -->
              </div>
              <div v-else>-</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="23" class="grid-item">
            <div class="grid-content" style="width: 90%">
              <span class="label-left">备注：</span>
              <span v-if="editRemark" class="desc-text overflow-two">{{
                userInfo.remarks || "-"
              }}</span>
              <el-input
                type="textarea"
                :rows="2"
                @blur="editRemark = true"
                v-else
                size="mini"
                v-model="userInfo.remarks"
              ></el-input>
            </div>
            <div
              class="grid-item-edit"
              v-if="!notShowEditText.includes(orderData.status)"
              @click="editRemark = false"
            >
              修改
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <div class="sub-title">设备详情</div>
      <el-table
        v-if="isCreat"
        v-loading="loading"
        empty-text="暂无数据"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="设备编码"
          width="200"
          prop="code"
        >
          <template #header>
            <span><span style="color: #f56c6c">* </span>设备编码</span>
          </template>
          <template slot-scope="coding">
            <el-autocomplete
              clearable
              v-model="userInfo.coding"
              :fetch-suggestions="devCodeSearchList"
              placeholder="请输入设备编码"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备型号"
          ><template slot-scope="scope">
            {{ scope.row.code_name || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="SN" width="185">
          <template slot-scope="sn">
            <el-autocomplete
              clearable
              v-model="userInfo.sn"
              :fetch-suggestions="SNSearchList"
              placeholder="请输入SN"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="IMEI"
          prop="customerName"
          width="170"
        >
          <template slot-scope="imei">
            <el-autocomplete
              clearable
              v-model="userInfo.imei"
              :fetch-suggestions="IMEISearchList"
              placeholder="请输入IMEI编码"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column align="center" label="MAC地址" prop="mac" width="185">
          <template slot-scope="mac">
            <el-autocomplete
              clearable
              v-model="userInfo.mac"
              :fetch-suggestions="MACSearchList"
              placeholder="请输入MAC地址"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="批次号"
          prop="batch_number"
          width="100"
        >
          <template slot-scope="scope">
            <div
              style="color: #165dff; cursor: pointer"
              @click="getBatchTable(scope.row.batchNumber)"
              v-if="scope.row.batch_number"
            >
              {{ scope.row.batch_number }}
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="固件版本"
          prop="firmware_version"
        >
          <template slot-scope="scope">
            {{ scope.row.firmware_version || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="绑定用户"
          prop="device.imei"
          width="120"
        >
          <template slot-scope="scope">
            {{ getBindUser(scope.row.bindUsers) || "-" }}
            <!-- <el-popover
              v-if="scope.row.bindUsers"
              trigger="hover"
              placement="top"
            >
              <div v-if="scope.row.bindUsers">
                <el-button
                  v-for="(item, index) in scope.row.bindUsers"
                  :key="index"
                  type="text"
                  @click="toUserDetail(item, index)"
                  >{{ item.name }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></el-button
                >
              </div>
              <div slot="reference">
                <div
                  v-if="scope.row.bindUsers"
                  style="
                    width: 90px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <span
                    v-for="(item, index) in scope.row.bindUsers"
                    :key="index"
                    type="text"
                    @click="toUserDetail(item, index)"
                    style="color: #165dff; cursor: pointer"
                    >{{ item.name
                    }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></span
                  >
                </div>
              </div>
            </el-popover>
            <div v-else>--</div> -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="激活日期"
          prop="first_bind_time"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.first_bind_time || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="保修" prop="warranty">
          <template slot-scope="scope">
            {{ scope.row.warranty || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-else
        v-loading="loading"
        empty-text="暂无数据"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="设备编码"
          width="180"
          prop="coding"
        >
          <template slot-scope="scope">
            <span class="click-table-item" @click="clickTableItem(scope.row)">{{
              scope.row.coding || "--"
            }}</span>
          </template>
          <!-- <template slot-scope="scope">
            {{ scope.row.coding || "--" }}
          </template> -->
          <!-- <template #header>
            <span><span style="color: #f56c6c">* </span>设备编码</span>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="设备型号"
          ><template slot-scope="scope">
            {{ scope.row.code_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="SN" width="170">
          <template slot-scope="scope">
            {{ scope.row.sn || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="IMEI"
          prop="customerName"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.imei || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="MAC地址" prop="mac" width="170">
          <template slot-scope="scope">
            {{ scope.row.mac || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="批次号"
          prop="batch_number"
          width="100"
        >
          <template slot-scope="scope">
            <div
              style="color: #165dff; cursor: pointer"
              @click="getBatchTable(scope.row.batchNumber)"
              v-if="scope.row.batch_number"
            >
              {{ scope.row.batch_number }}
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="固件版本"
          prop="firmware_version"
        >
          <template slot-scope="scope">
            {{ scope.row.firmware_version || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="绑定用户" width="200">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.bindUsers"
              trigger="hover"
              placement="top"
            >
              <div v-if="scope.row.bindUsers">
                <el-button
                  v-for="(item, index) in scope.row.bindUsers"
                  :key="index"
                  type="text"
                  @click="toUserDetail(item, index)"
                  >{{ item.name
                  }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                    >、</span
                  ></el-button
                >
              </div>
              <div slot="reference">
                <div
                  v-if="scope.row.bindUsers"
                  style="
                    width: 165px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <span
                    v-for="(item, index) in scope.row.bindUsers"
                    :key="index"
                    type="text"
                    @click="toUserDetail(item, index)"
                    style="color: #165dff; cursor: pointer"
                    >{{ item.name
                    }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></span
                  >
                </div>
              </div>
            </el-popover>
            <div v-else>--</div>
            <!-- <div
              v-if="scope.row.bindUsers && scope.row.bindUsers.length > 0"
              class="bind-user"
            >
              <span
                v-for="(i, index) in scope.row.bindUsers"
                @click="toUserDetail(i)"
                :key="index"
                class="user-name click-table-item"
                >{{ i.name
                }}<span v-if="index < scope.row.bindUsers.length - 1">、</span>
              </span>
            </div>
            <div v-else>--</div> -->
          </template>
          <!-- <template slot-scope="scope">
            {{ getBindUser(scope.row.bindUsers) || "--" }}
          </template> -->
        </el-table-column>
        <el-table-column
          align="center"
          label="激活日期"
          prop="created_at"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.firstBindTime || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="保修" prop="warranty">
          <template slot-scope="scope">
            {{ scope.row.warranty || "--" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="批次查看"
      :visible.sync="mskflag"
      :fullscreen="true"
      center
      @close="batchDialogClose"
    >
      <div class="batch-info">
        <span class="info-title">批次编号:</span><span>{{ batchDialogId }}</span
        ><span class="info-title" style="padding-left: 100px">总设备数:</span
        ><span>{{ batchTotal }}台</span>
      </div>
      <div class="table">
        <el-table
          :data="batchTableData"
          empty-text="暂无数据"
          :border="true"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="date"
            label="设备编码"
            width="220"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  color: $jumpPerm('device_detail') ? '#165DFF' : '#606266',
                }"
                @click="goDevDetail(scope.row._id)"
              >
                {{ scope.row._id || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="设备型号">
            <template slot-scope="scope">
              {{ scope.row.code_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="固件版本">
            <template slot-scope="scope">
              {{ scope.row.firmware_version || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="订单类型">
            <template slot-scope="scope">
              {{
                scope.row.production_type === 1
                  ? "量产"
                  : scope.row.production_type === 2
                  ? "试产"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="生产厂商">
            <template slot-scope="scope">
              {{ scope.row.manufacturer_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="语言">
            <template slot-scope="scope">
              {{
                scope.row.language === 1
                  ? "中文"
                  : scope.row.language === 2
                  ? "英文"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            :current-page="batchPage"
            layout="total,prev, pager, next"
            @current-change="currentChangefn"
            :total="batchTotal"
            :page-size="batchSize"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import uploadFile from "./uploadFile.vue";
import { getDictMap } from "../../../utils/util";
import { DeviceLists } from "@/api/device.js";
import imgPreview from "./imgPreview.vue";
export default {
  name: "afterSaleInfo",
  components: {
    uploadFile,
    imgPreview,
  },
  props: {
    orderData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isCreat: {
      type: Boolean,
      default: false,
    },
    devId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editCusName: true,
      editContact: true,
      editDesc: true,
      editRemark: true,
      rules: {
        category: [
          { required: true, message: "请输入售后类型", trigger: "change" },
        ],
        problemDescription: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
        coding: [
          { required: true, message: "请输入设备编码", trigger: "blur" },
        ],
      },
      size: 10,
      total: 0,
      page: 1,
      loading: false,
      fileList: [],
      userInfo: {
        customerName: "",
        category: "",
        source: "",
        code: "",
        creatorName: "",
        createdAt: "",
        contact: "",
        problemDescription: "",
        attachment: "",
        remarks: "",
        gdid: "",
        sn: "",
        imei: "",
        mac: "",
        coding: "",
      },
      afterSaleType: [],
      originType: [],
      tableData: [{}],
      attachmentLists: [],
      form: {},
      dictMap: {},
      notShowEditText: [],
      mskflag: false,
      batchDialogId: "",
      batchTotal: 0,
      batchTableData: [{}],
      batchPage: 1,
      batchSize: 20,
    };
  },
  beforeMount() {
    this.dictMap = getDictMap();
    if (this.devId) {
      this.getDevDetail(this.devId);
    }
    // console.log("this.dictMap++-", this.dictMap);
  },
  mounted() {
    // this.getDevList();
    this.getDict();
    this.notShowEditText = [
      this.dictMap["returned"]?.id, //已退回
      this.dictMap["returned_inventory"]?.id, //已退货
      this.dictMap["cancelled"]?.id, //已取消
      this.dictMap["to_be_sent_out"]?.id, //待寄出
      this.dictMap["sent_out"]?.id, //已寄出
      this.dictMap["to_be_returned"]?.id, //待退回
    ];
  },
  watch: {
    orderData(newVal) {
      if (
        Object.keys(this.orderData) &&
        Object.keys(this.orderData)?.length !== 0
      ) {
        const device = newVal.device;
        if (
          this.orderData.attachmentList &&
          this.orderData?.attachmentList.length > 0
        ) {
          this.attachmentLists = this.orderData.attachmentList;
          console.log("组件中的attachmentLists", this.attachmentLists);
        }
        // this.userInfo = { ...newVal };
        this.userInfo = {
          ...this.userInfo,
          ...Object.fromEntries(
            Object.keys(this.userInfo).map((key) => [key, newVal[key]])
          ),
        };
        this.tableData = [
          {
            ...device,
            creatorName: this.userInfo.creatorName,
            customerName: this.userInfo.customerName,
            code_name: device.code,
            batch_number: device.batchNumber,
            created_at: device.firstBindTime,
            firmware_version: device.firmwareVersion,
          },
        ];
      }
    },
  },
  methods: {
    async getBatchTable(id) {
      console.log("getBatchTable", id);
      // return;
      this.mskflag = true;
      this.batchDialogId = id;
      const { data } = await DeviceLists({
        page: this.batchPage,
        size: this.batchSize,
        batch_number: id,
      });
      if (data.code === 1000) {
        this.batchTableData = data.data.list;
        this.batchTotal = data.data.count;
      } else {
        this.$message.error(data.msg);
      }
    },
    // 切换批次号弹窗表格页码值
    currentChangefn(index) {
      this.batchPage = index;
      this.getBatchTable(this.batchDialogId);
    },
    // 批次号弹窗关闭
    batchDialogClose() {
      this.batchPage = 1;
    },
    getDevDetail(id) {
      this.$get("device/detail", {
        id,
      }).then((res) => {
        if (res.data.code === 1000) {
          const data = res.data.data?.data;
          // console.log("设备详情", data);
          this.userInfo = {
            // ...data,
            coding: data.coding,
            sn: data.sn,
            imei: data.imei,
            mac: data.mac,
            gdid: data._id,
          };
          this.tableData = [
            {
              ...data,
              creatorName: this.userInfo.creatorName,
              customerName: this.userInfo.customerName,
              // code_name: data.code_name,
              // batch_number: data.batchNumber,
              // created_at: data.firstBindTime,
              // firmware_version: data.firmwareVersion,
            },
          ];
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    toUserDetail(item) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: item.id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    clickTableItem(item) {
      if (this.$jumpPerm("device_detail")) {
        this.$router.push({
          path: "/devDetail",
          query: {
            id: item.id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getAfterSaleText(id) {
      const type = this.afterSaleType.find((item) => item.id === id);
      return type ? type.name : "";
    },
    getSourceText(id) {
      const type = this.originType.find((item) => item.id === id);
      return type ? type.name : "";
    },
    fileChange(flie) {
      this.userInfo.attachment = flie.join(",");
    },
    getBindUser(list) {
      if (list && list.length > 0) {
        return list.map((i) => i.name).join("、");
      } else {
        return "";
      }
    },

    devCodeSearchList(queryString, cb) {
      this.searchList(queryString, cb, 1);
    },
    SNSearchList(queryString, cb) {
      this.searchList(queryString, cb, 2);
    },
    IMEISearchList(queryString, cb) {
      this.searchList(queryString, cb, 3);
    },
    MACSearchList(queryString, cb) {
      this.searchList(queryString, cb, 4);
    },
    searchList(queryString, cb, type) {
      if (queryString) {
        this.getDevList(queryString, cb, type);
      } else {
        cb([]);
      }
    },
    getDevList(queryString, cb, type) {
      const params =
        {
          1: { coding: queryString },
          2: { sn: queryString },
          3: { imei: queryString },
          4: { mac: queryString },
        }[type] || {};

      this.$get("/device/lists", {
        page: 1,
        size: 5,
        ...params,
      }).then((res) => {
        const list = res.data.data.list;
        const arr = list.map((i) => ({
          ...i,
          value: i[Object.keys(params)[0]],
        }));
        cb && cb(arr);
      });
    },
    handleSelect(item) {
      this.tableData = [item];
      const { coding, sn, imei, mac, _id } = item;

      this.userInfo.coding = coding;
      this.userInfo.sn = sn;
      this.userInfo.imei = imei;
      this.userInfo.mac = mac;
      this.userInfo.gdid = _id;
    },
    changepagefn(index) {
      this.page = index;
    },
    getDict() {
      this.afterSaleType = this.dictMap["after_sales_type"]?.children;
      this.originType = this.dictMap["selling_source"]?.children;
    },
  },
};
</script>

<style lang="less" scoped>
.sub-title {
  margin: 20px 0;
  font-size: 16px;
  font-weight: 500;
}
.bottom-btn {
  width: 100%;
  text-align: center;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    //background: #f2f3f5;
    // border: none;
  }
}
::v-deep .el-input__count {
  line-height: 12px;
  // background: #f2f3f5 !important;
}
.grid-content {
  margin: 12px 0;
  font-weight: 500;
  font-size: 14px;
  color: #86909c;
  display: flex;
  align-items: center;
  input {
    height: 22px;
  }
}
.label-left {
  display: inline-block;
  width: 110px;
}
.desc-text {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
.overflow-text {
  //一行不换行隐藏
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding-left: 10px;
}
.overflow-two {
  overflow: hidden;
  word-break: break-all;
}
.picture-space {
  display: flex;
  align-items: flex-start;
  img {
    width: 80px;
    height: 80px;
    margin-right: 12px;
  }
}
.picture-video {
  // width: 650px;
  margin-bottom: 12px;
}
.grid-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .grid-item-edit {
    font-weight: 400;
    font-size: 12px;
    color: #165dff;
    cursor: pointer;
  }
}
.click-table-item {
  color: #165dff;
  cursor: pointer;
}
.bind-user {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.user-name {
  flex-shrink: 0; /* 不允许缩小 */
}
</style>
